export const getUrlDeleteUser = () => '/v3/delete_user_request';

export const getUrlLocationTypesList = () => '/v3/location_types/';
